// extracted by mini-css-extract-plugin
export default {"active-link":"styles_active-link__cOb+5","link":"styles_link__kMkcs","sidebar":"styles_sidebar__T3IKw","img":"styles_img__ayJ39"};